// FILE: src/services/common.js (FULLY UPDATED)

import axiosServices from "./axios";

// This function was already here and is retained.
export function formatDate(timestamp) {
  let date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// --- START: ADDED NEW FUNCTIONS ---

export const fetchCountries = async () => {
    try {
        const response = await axiosServices.get('/common/countries');
        return response.data; // Should be an array of strings
    } catch (error) {
        console.error("Error fetching countries:", error);
        return []; // Return empty array on failure
    }
};

export const fetchTimezones = async () => {
    try {
        const response = await axiosServices.get('/common/timezones');
        return response.data; // Should be an array of strings
    } catch (error) {
        console.error("Error fetching timezones:", error);
        return []; // Return empty array on failure
    }
};
// --- END: ADDED NEW FUNCTIONS ---